const teliaAnalyticsExist = () => {
  if (!window.teliaAnalytics) {
    // eslint-disable-next-line no-console
    console.error('Telia Analytics not present!')
    return false
  }
  return true
}

export default {
  pageView (path: string) {
    if (teliaAnalyticsExist()) {
      window.teliaAnalytics.pageview(path, -1)
    }
  },

  collect (category: string, label?: string) {
    if (teliaAnalyticsExist()) {
      window.teliaAnalytics.collect(
        {
          t: 'event',
          ea: 'Click',
          ec: category,
          el: label || 'UNKNOWN'
        }
      )
    }
  }
}
